import React from "react";
import { Global, css } from "@emotion/react";

const GlobalStyle = () => (
  <Global
    styles={css`
      @import url("https://fonts.googleapis.com/css?family=Noto+Sans+TC");
      
      * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        line-height: 1.5;
        outline: none;
        font-family: "Noto Sans TC", "微軟正黑體";
        -webkit-tap-highlight-color: transparent;
        letter-spacing: 0.8px;
      }
      li {
        list-style-type: none;
      }
      button {
        background-color: transparent;
        border: none;
      }
      a {
        text-decoration: none;
      }
      html > body {
        width: 100%;
        overflow-x: hidden;
        padding-right: 0px !important;
      }
      br {
        line-height: 0;
      }
      img {
        vertical-align: middle;
      }
      .toyotaFont {
        font-family: toyota;
      }
      /* wrc */
      .schedule.slick-initialized .slick-slide {
        padding: 0px 5px;
      }
      .schedule .slick-center {
        * div {
          opacity: 1;
          transition: all 0.5s;
        }
      }
      .schedule .slick-dots {
        bottom: -50px;
      }
      .schedule .slick-dots li.slick-active button:before {
        color: #fff;
      }
      .schedule .slick-dots li button:before {
        color: #555;
      }
      .thumbY,
      .trackX {
        background-color: #585858 !important;
        > div {
          background-color: #afafaf !important;
        }
      }
      .thumbY {
        right: -10px !important;
        width: 5px !important;
      }
      .trackX {
        left: 50% !important;
        transform: translateX(-50%);
        bottom: -10px !important;
        height: 5px !important;
      }
      .question input[type="radio"] {
        display: none;
        visibility: hidden;
      }
      .question  input[type="radio"]:checked + label {
        > div {
          opacity: 1;
        }
      }

      input[type="checkbox"] {
        display: none;
        visibility: hidden;
      }
      input[type="checkbox"]:checked + label {
        > div {
          /* background-color: #fff; */
          img {
            opacity: 1;
          }
        }
      }
      .slick-dots li {
        margin: 0;
      }
    `}
  />
);

export default GlobalStyle;
